interface Props {
    text: string;
    label?: string;
    testId?: string;
}

export function InfoNote({ text, label, testId }: Props) {
    return (
        <div className="rounded-xl border border-sand bg-sandsoft/60 p-3" data-testid={testId}>
            {label && <p className="mb-1.5 font-mono text-[10.5px] uppercase tracking-wide text-inkfaint">{label}</p>}
            <p className="whitespace-pre-wrap font-mono text-[12.5px] leading-relaxed text-ink">{text}</p>
        </div>
    );
}
